<div class="history-dialog">
  @if (isLoading() && audits().length === 0) {
    <div class="history-empty">Loading history…</div>
  } @else if (audits().length === 0) {
    <div class="history-empty">No overrides yet. Edit a cell to start the log.</div>
  } @else {
    <ul class="history-list">
      @for (e of audits(); track e.id) {
        <li class="history-row">
          <div class="history-line">
            <span class="action-tag" [ngClass]="actionTagClass(e.action)">
              {{ e.action === 'added' ? 'Added' : e.action === 'changed' ? 'Updated' : 'Cleared' }}
            </span>
            <span class="history-where">
              <strong>{{ e.monthly_finance.monthly_finance_type.label }}</strong>
              · {{ monthLabel(e.monthly_finance.year, e.monthly_finance.month) }}
            </span>
          </div>
          <div class="history-meta">
            {{ propertyLabel(e.monthly_finance.address_id) }} ·
            {{ e.monthly_finance.kind === 'actual' ? actualsLabel : 'Projected' }} ·
            {{ formatTimestamp(e.created_at) }} ·
            {{ actorLabel(e) }}
          </div>
          <div class="history-values">
            @if (e.action === 'changed') {
              <span class="history-prev">{{ formatAmount(e.old_value) }}</span>
              <span class="history-arrow">→</span>
              <span class="history-new">{{ formatAmount(e.new_value) }}</span>
            } @else if (e.action === 'added') {
              <span class="history-new">{{ formatAmount(e.new_value) }}</span>
            } @else {
              <span class="history-prev">was {{ formatAmount(e.old_value) }}</span>
            }
          </div>
        </li>
      }
    </ul>

    @if (hasMore()) {
      <button class="load-more-btn" [disabled]="isLoadingMore()" (click)="loadMore()">
        {{ isLoadingMore() ? 'Loading…' : 'Load more' }}
      </button>
    }
  }
</div>
